import { getVars } from '~/managers/styles'
import { getCombinedVarsObject } from '~/utils/convertors';

export default ({ $config, store }, inject) => {
    const THEME = $config.THEME;
    const vars = getVars(THEME)
    const colors = store?.state?.global?.globalSettings?.colors?.dark_theme || null // WEAK CODE: not reliable code, colors may be stored in another object, have to make dynamic
    const handledVars = getCombinedVarsObject(vars, colors)

    // TO DO: have to refactoring this injection, require dynamic values from globalSettings.colors

    inject('stylesVars', handledVars)
}